import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './ADRPrice.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import OtherMarketOption from "../../OtherMarketOption/OtherMarketOption";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function ADRPrice() {
    const [data, setData] = useState([]);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);

    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "OtherMarkets";
        fetch(`${getUrl}/ADR/20`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false);

            })
            .catch((error) => {
            });


    }, []);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("ADR Prices",window.location.href);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>ADR Prices</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='ADR-loser-sc'>
                            <div className='ADR-header'>
                                <h2><span>ADR Price</span></h2>
                            </div>
                            <OtherMarketOption optionOtherMarket="ADR Prices" />
                            <hr className="ADRhr"></hr>
                            <div className='ADR-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className='text-left' >Symbol</th>
                                            <th className='text-left' >Company</th>
                                            <th className='text-right' >Last Price US $</th>
                                            <th className='text-right'>Net Change US $</th>
                                            <th className='text-right'>Change(%)</th>
                                            <th className='text-right'>Volume(NoS.)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ SymbolName, LNAME, LastSale, NChange, PChange, SVol, CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left"> {SymbolName}</td>
                                                    <td className="text-left">
                                                        {/* <h6 onClick={routeChange} data-id={LNAME + '-' + CO_CODE}> */}
                                                            {LNAME}</td>

                                                    <td className="text-right"> {(LastSale != null) ? LastSale.toFixed(2) : 0}</td>

                                                    <td><p className={NChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {NChange != null ? NChange.toFixed(2) : 0} </p></td>
                                                    <td><p className={PChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {PChange != null ? PChange.toFixed(2) : 0}</p></td>
                                                    <td className="text-right"> {SVol}</td>



                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ADRPrice;